<template>
  <li class='checklist-item' :class="dynamicClasses">
    {{ this.status.name }}
    <span v-if="showCheck" class="float-right"><v-icon medium color="green">done</v-icon></span>
    <span v-if="showSpinner" class="float-right"><v-progress-circular indeterminate color="white"></v-progress-circular></span>
  </li>
</template>

<script>
export default {
  props: ['buyStatus', 'status'],
  data () {
    return {
    }
  },
  computed: {
    isInactive () {
      return this.buyStatus.id < this.status.id
    },
    isActive () {
      return this.buyStatus.id === this.status.id
    },
    isComplete () {
      return this.buyStatus.id > this.status.id
    },
    showCheck () {
      return (this.isComplete || (this.isActive && this.status.type === 'complete'))
    },
    showSpinner () {
      return (this.isActive && this.status.type !== 'complete')
    },
    dynamicClasses () {
      return {
        'complete': this.isComplete,
        'active': this.isActive,
        'text-muted': this.isInactive
      }
    }

  },
  filters: {
    capitalize (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>

<style scoped>
  li.checklist-item {
    position: relative;
  }

  span.float-right {
    position: absolute;
    right: 0.5em;
    top: 0.2em;
  }
  


  li.active {
    color: white;
    background: #33b8e2; /* Old browsers */
    background: -moz-linear-gradient(left, #33b8e2 0%, #309bd1 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, #33b8e2 0%,#309bd1 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, #33b8e2 0%,#309bd1 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    /* filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#33b8e2', endColorstr='#309bd1',GradientType=1 ); IE6-9 */
  }

  li:before {
    counter-increment: step;
    content: counter(step) '. ';
  }

  li {
    padding: 0 0.5em;
    margin: 0em 0em;
  }

</style>



// WEBPACK FOOTER //
// src/components/CheckInStatusItem.vue